import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: "app-auth-callback",
    templateUrl: "./auth-callback.component.html",
    styleUrls: ["./auth-callback.component.scss"],
    standalone: true
})
export class AuthCallbackComponent implements OnInit {
    token: string = '';
    service: string = '';
    authorized: boolean = false;
    countdown: number = 5;

    constructor(
        private route: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        // Get token and service from URL query parameters
        this.route.queryParams.subscribe(params => {
            this.token = params['token'] || '';
            this.service = params['service'] || '';

            if (this.token && this.service) {
                this.authorized = true;
                this.storeTokenAndNotify();
                this.closeWindow();
            }
        });
    }

    private storeTokenAndNotify(): void {
        // Store token to localStorage with service name as key
        const storageKey = `${this.service}_token`;
        localStorage.setItem(storageKey, this.token);

        console.log(`Token stored to localStorage for ${this.service}:`, this.token);
    }
    
    private closeWindow(): void {
        // Try to close the window (works if opened via window.open)
        setTimeout(() => {
            try {
                 window.close();
            } catch (e) {
                console.error("Error closing window:", e);
            }
        }, this.countdown * 1000);
    }
}
